const $ = require('jquery');

module.exports = {
    init: () => {
        const $wrapper = $('.js-drop-navigation__wrapper');
        const wrapperHeight = 96;

        if ($(window).width() > 800) {
            $wrapper.css('height', `${wrapperHeight}px`);
        }

        $('.js-drop-navigation > ul > li').on('mouseenter', (e) => {
            $subMenu = $(e.currentTarget).children('.js-drop-navigation__sub');

            if ($(window).width() > 800 && $subMenu.length > 0) {
                let subMenuHeight = $subMenu.height();
                let newHeight = wrapperHeight + subMenuHeight;
                $wrapper
                    .css('height', `${newHeight}px`)
                    .addClass('is-open');
            }
        });

        $('.js-drop-navigation > ul > li').on('mouseleave', (e) => {
            $subMenu = $(e.currentTarget).children('.js-drop-navigation__sub');
            if ($(window).width() > 800 && $subMenu.length > 0) {
                $wrapper
                    .css('height', `${wrapperHeight}px`)
                    .removeClass('is-open');
            }
        });

        $('.js-mobile-nav').on('click', function(event) {
            event.preventDefault();

            mobileMenu($('.main-nav'), mainMenuHeight);

        });

        function mobileMenu(element, initialHeight) {
            if (!element.hasClass('menu-is-open')) {
                element.addClass('menu-is-open');
                const mainNavMenuHeight = element.find('.main-nav__menu').outerHeight();

                let langNavMenuHeight;

                if($('.main-nav__lang-menu').length > 0) {
                    langNavMenuHeight = element.find('.main-nav__lang-menu').outerHeight();
                }
                else {
                    langNavMenuHeight = 0;
                }

                const mobileNavHeight = mainNavMenuHeight + langNavMenuHeight + 70 + initialHeight; //70 is for social menu
                element.css('height', mobileNavHeight+'px');
            } else {
                element.removeClass('menu-is-open');
                element.css('height', initialHeight);
            }
        }
    },
};
